import { ArrowRight } from '@travel/icons/ui';

import {
  BREADCRUMB_FAVORITE_LIST_LINK_TEXT,
  BREADCRUMB_TOP_PAGE_LINK_TEXT,
} from 'favoriteList/constants/common';

import styles from './breadcrumbfavorite.module.scss';

const BreadcrumbFavorite = () => {
  return (
    <div className={styles.container}>
      <a
        className={styles.mainPageLink}
        rel="noopener noreferrer"
        href={'https://travel.rakuten.co.jp'}
      >
        <span>{BREADCRUMB_TOP_PAGE_LINK_TEXT}</span>
      </a>
      <ArrowRight size={12} />
      <span>{BREADCRUMB_FAVORITE_LIST_LINK_TEXT}</span>
    </div>
  );
};

export default BreadcrumbFavorite;
